import PwaDiagnosticLogController from "./pwa/diagnostic_log_controller"
import db from "../field_db"

// Field app diagnostic log -- extends shared base with field_db.
export default class extends PwaDiagnosticLogController {
  get _db() { return db }
  get _tableName() { return "app_log" }
}
